import Vue from 'vue';
import App from './App.vue';
import store from './store/store'
import "./plugins/axios";

import "./registerServiceWorker";
import router from "./router";

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import moment from 'moment';
import { funcoes } from './assets/js/funcoes.js';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import "./assets/css/estilo.css";
import '@fortawesome/fontawesome-free/css/all.css';
import './registerServiceWorker';

import "leaflet/dist/leaflet.css";
import { Icon } from "leaflet";

import SocketIO from 'socket.io-client';
import VueSocketIO from 'vue-socket.io';

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
    iconUrl: require("leaflet/dist/images/marker-icon.png"),
    shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

Vue.prototype.$func = funcoes;
Vue.prototype.$moment = moment;
const idAtendimento = "";

var filter = function(text, length, clamp){
    clamp = clamp || '...';
    var node = document.createElement('div');
    node.innerHTML = text;
    var content = node.textContent;
    return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.use(BootstrapVue);
Vue.use(Toast, {});
Vue.use(IconsPlugin);
Vue.use(funcoes);
Vue.use(new VueSocketIO({
    connection: SocketIO(process.env.VUE_APP_SOCKET_API, {
        autoConnect: false,
        query: { idAtendimento },
    }),
    vuex: {
        store,
        actionPrefix: "SOCKET_",
        mutationPrefix: "SOCKET_"
    }
}));
Vue.filter('truncate', filter);
Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
